import bowser from 'bowser'

import urls from '../constants/urls'

import {
  gatherErrors
} from '../utils/errorHandling'

export const CREATE_ENQUIRY_FAILED = 'enquirys/CREATE_ENQUIRY_FAILED'
export const CREATE_ENQUIRY_SUCCESS = 'enquirys/CREATE_ENQUIRY_SUCCESS'
export const CREATING_ENQUIRY = 'enquirys/CREATING_ENQUIRY'

const initialState = {
  createErrors: {},

  failedCreating: false,

  hasLoaded: false,

  isCreating: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATING_ENQUIRY:
      return {
        ...state,
        createErrors:   {},
        isCreating:     true,
        failedCreating: false
      }

    case CREATE_ENQUIRY_SUCCESS:
      return {
        ...state,
        createErrors: {},
        isCreating:   false
      }

    case CREATE_ENQUIRY_FAILED:
      return {
        ...state,
        createErrors:   gatherErrors(action.error, 'could_not_create_support_ticket'),
        isCreating:     false,
        failedCreating: true
      }

    default:
      return state
  }
}

export const createEnquiry = (params) => (dispatch) => {
  const browser = bowser.getParser(window.navigator.userAgent)

  const enquiryParams = {
    app_version:      import.meta.env.VITE_VERSION,
    device_model:     `${browser.getOSName()} ${browser.getOSVersion()}`,
    platform:         browser.getBrowserName(),
    platform_version: browser.getBrowserVersion(),

    hospital_name:    params.hospitalName,
    contact_number:   params.contactNumber,
    email:            params.email,
    message:          params.ticket,
    name:             params.name,
    subject:          params.subject
  }

  if (params.freeform_subject.length > 0) {
    enquiryParams.subject = params.freeform_subject
  }

  return dispatch({
    types:   [CREATING_ENQUIRY, CREATE_ENQUIRY_SUCCESS, CREATE_ENQUIRY_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.enquiries.create,
        data:   { support_ticket: enquiryParams }
      }
    }
  })
}
